<template>
  <transition name="fade">
    <div
      v-if="menu"
      class="mega-nav grid"
    >
      <div
        v-for="tier of menu.links"
        :key="tier.handle"
        :class="{
          'col l1-4': !tier.title.startsWith('[Menu Block]'),
          'col l5-12': tier.title.startsWith('[Menu Block]')
        }"
      >
        <div
          v-if="tier.title.startsWith('[Menu Block]')"
          class="mega-nav__section"
        >
          <span
            class="mega-nav__title text-body-s-bold"
            v-text="menuBlockTitle(tier.title)"
          />
          <div
            v-if="menuBlocks.length > 1"
            class="mega-nav__carousel-buttons"
          >
            <button
              :aria-label="$string('accessibility.carousel.previous')"
              type="button"
              class="mega-nav__arrow"
              :disabled="onFirstSlide"
              @click="goToPreviousSlide"
            >
              <icon-chevron-left />
            </button>
            <button
              :aria-label="$string('accessibility.carousel.next')"
              type="button"
              class="mega-nav__arrow"
              :disabled="onLastSlide"
              @click="goToNextSlide"
            >
              <icon-chevron-right />
            </button>
          </div>
          <div class="mega-nav__menu-blocks">
            <splide
              ref="splide"
              :has-track="false"
              :options="carouselOptions"
              @splide:moved="onMove"
            >
              <splide-track class="mega-nav__track">
                <splide-slide
                  v-for="(block, index) of menuBlocks"
                  :key="`block-${index}`"
                >
                  <menu-block :block="block" />
                </splide-slide>
              </splide-track>
            </splide>
          </div>
        </div>

        <div
          v-else
          class="mega-nav__section"
        >
          <span
            class="mega-nav__title text-body-s-bold"
            v-text="tier.title"
          />
          <div class="mega-nav__links">
            <div
              v-for="(link, index) of tier.links"
              :key="link.id"
            >
              <a
                :href="menuLinkUrl(link.url)"
                class="mega-nav__link text-body-s"
                :class="{'text-body-s-bold': index === tier.links.length - 1}"
                :style="linkStyle(link.title)"
                v-text="link.title"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

/**
 * Vue: MegaNav (mega-nav)
 * -----------------------------------------------------------------------------
 * The sites Mega Nav.
 *
 */
import MenuBlock from '~async/menu-block/menu-block'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide'
import IconChevronRight from '~icons/direction/chevron/right.svg'
import IconChevronLeft from '~icons/direction/chevron/left.svg'

export default {
  name: 'MegaNav',

  components: {
    MenuBlock,
    Splide,
    SplideSlide,
    SplideTrack,
    IconChevronRight,
    IconChevronLeft,
  },

  props: {
    menu: {
      type: Object,
      default: () => ({}),
    },
    menuBlocks: {
      type: Array,
      default: () => [],
    },
    linkStyles: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      cnvsGlobal: true,
      onFirstSlide: true,
      onLastSlide: false,
      carouselOptions: {
        type: 'slide',
        rewind: false,
        pagination: false,
        arrows: false,
        fixedWidth: '25%',
        gap: '0.25rem',
        waitForTransition: true,
      },
    }
  },

  methods: {
    menuBlockTitle(title) {
      return title.split('[Menu Block]')[1]
    },

    /**
     * Adds link styling from metaobject
     * @param {String} link -the link that's being styled
     */
    linkStyle(link) {
      if (!this.linkStyles[link]) {
        return
      }

      return {
        color: this.linkStyles[link] || '',
      }
    },

    /**
     * Quick and dirty fix so that we don't get CORS issues in the page
     * will need a better fix in the future
     * @param {String} link - the link that's being transformed
     */
    menuLinkUrl(link) {
      const newLink = link.replace(cnvs.store.permanentDomain, cnvs.store.shopDomain)
      return newLink
    },

    goToNextSlide() {
      const splide = this.$refs.splide

      if (splide.length > 0) {
        splide[0].go('>')
      }
    },

    goToPreviousSlide() {
      const splide = this.$refs.splide

      if (splide.length > 0) {
        splide[0].go('<')
      }
    },

    onMove(event, newIndex, prevIndex) {
      const splide = this.$refs.splide[0]
      const width = parseInt(this.carouselOptions.fixedWidth)

      this.onLastSlide = newIndex === splide.length - (100 / width)
      this.onFirstSlide = newIndex === 0
    },

  },
}
</script>

<style lang="scss">
@import '@splidejs/vue-splide/css/core';
@import './mega-nav';
</style>
